import React from 'react';
import PropTypes from 'prop-types';
import { formatAgreementDateLabel, getAgreementBodyContent } from '../../lib/agreementContent';

/** Renders approved structured agreement body for a language (or empty if missing). */
export default function AgreementBodyView({
  agreementKey,
  languageCode,
  acceptedAt,
  contentRef,
}) {
  const content = getAgreementBodyContent(agreementKey, languageCode);
  if (!content) return null;

  const dateLabel = acceptedAt
    ? new Date(acceptedAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })
    : formatAgreementDateLabel();
  const meta = typeof content.metaRows === 'function' ? content.metaRows(dateLabel) : content.metaRows || [];

  return (
    <div
      ref={contentRef}
      data-testid={`agreement-body-${agreementKey}-${languageCode}`}
      style={{
        padding: '36px 24px',
        fontFamily: 'Georgia, serif',
        color: '#1a1a1a',
        lineHeight: '1.75',
        fontSize: '16px',
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h1 style={{ fontSize: '26px', fontWeight: '700', letterSpacing: '1px', marginBottom: '6px' }}>
          {content.heading}
        </h1>
        <p style={{ fontSize: '13px', color: '#888', letterSpacing: '1px', textTransform: 'uppercase' }}>
          {content.companyLine}
        </p>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '28px', fontSize: '15px' }}>
        <tbody>
          {meta.map(([k, v]) => (
            <tr key={k}>
              <td style={{ padding: '8px 12px', border: '1px solid #ddd', fontWeight: '600', width: '40%', background: '#f9f9f9' }}>
                {k}
              </td>
              <td style={{ padding: '8px 12px', border: '1px solid #ddd' }}>{v}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {(content.sections || []).map(({ title, body, bullets }) => (
        <div key={title} style={{ marginBottom: '20px' }}>
          <h2 style={{ fontSize: '17px', fontWeight: '700', color: '#1B6EF3', marginBottom: '8px' }}>{title}</h2>
          {body ? <p style={{ margin: 0 }}>{body}</p> : null}
          {bullets ? (
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              {bullets.map((b) => (
                <li key={b} style={{ marginBottom: '4px' }}>{b}</li>
              ))}
            </ul>
          ) : null}
        </div>
      ))}
      <div style={{ borderTop: '1px solid #ddd', marginTop: '32px', paddingTop: '16px', fontSize: '12px', color: '#888', textAlign: 'center' }}>
        {content.footer}
      </div>
    </div>
  );
}

AgreementBodyView.propTypes = {
  agreementKey: PropTypes.string.isRequired,
  languageCode: PropTypes.string.isRequired,
  acceptedAt: PropTypes.string,
  contentRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
};
